<template>
    <div class="product flex-con is-grow sm-pad-lr is-start">
        <div class="images-col">
            <router-link :to="linkTo">
                <div class="primary-image">
                    <img v-if="images[0]" :src="$srcOverwrite(images[0])" class="image">
                    <i v-else class="fa fa-image"></i>
                </div>
            </router-link>
        </div>
        <div class="base-col">
            <div><router-link :to="linkTo" class="heading" v-html="title"/></div>
            <div class="flex-con sm-pad-lr">
                <div v-if="showSku" class="meta">
                    <b>SKU:</b> {{product.productSku}}
                </div>
                <div v-if="showQuantity" class="meta">
                    <b>Qty: </b> <number :value="product.summedQuantity"></number>
                    <span v-if="product.totalVariants > 1"> ({{product.totalVariants}} options)</span>
                </div>
                <div class="meta" v-if="product.categoryOne">
                    <b>Category:</b> <span v-html="product.categoryOne" class="m-l-xs"/>
                    <span v-if="product.categoryTwo" class="m-l-xs">
                        <i class="fa fa-angle-right m-r-xs"></i>
                        <span v-html="product.categoryTwo"/>
                    </span>
                </div>
            </div>
            <div class="description">
                {{description}}
            </div>
        </div>
        <div class="is-narrow is-start m-l-xl">
            <div class="price">
                <div v-if="price.showRange">
                    <money :value="price.min"/> - <money :value="price.max"/>
                </div>
                <money
                    v-else
                    :value="price.min"
                    or="Price Currently Unavailable"
                />
            </div>
            <template v-if="showCheckout">
                <div
                    class="button"
                    :class="buttonInfo.className"
                    @click="buttonClick"
                >
                    {{buttonInfo.text}}
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import AddToCartButton from "../../../components/products/AddToCartButton";
import AccountSettingsMixin from "../../../mixins/AccountSettingsMixin";
export default {
    name : "ProductItemDisplay",
    components : {AddToCartButton},
    mixins : [AccountSettingsMixin],
    props : {
        product : {
            type : Object,
            required : true,
        },
    },
    data () {
        return {
        }
    },
    computed : {
        linkTo () {
            return {
                name : this.$ROUTES.PRODUCTS_VIEW,
                params : {
                    id : this.product.productId
                }
            };
        },
        title () {
            return this.product.productTitle ? this.product.productTitle : this.product.variantTitle;
        },
        description () {

            if(!this.product.productDescription) {
                return null;
            }
            let desiredLength = 180;
            const desc = this.product.productDescription.replace(/<[^>]*>?/gm, '');
            if(!desc || desc.length < desiredLength){
                return desc;
            }
            const breakOn = [' ', '!', '.', ',', '?'];
            do {
                desiredLength++;
            } while(desc[desiredLength] && breakOn.indexOf(desc[desiredLength]) === -1)
            return desc.substring(0, desiredLength) + '...';
        },
        images () {
            if(this.product.productImages) {
                return JSON.parse(this.product.productImages);
            }
            if(this.product.variantImages) {
                return JSON.parse(this.product.variantImages);
            }
            return [];
        },
        price () {
            return {
                min : this.product.minPrice,
                max : this.product.maxPrice,
                showRange : this.product.minPrice !== this.product.maxPrice,
            };
        },
        buttonInfo () {
            if(!this.allowBackorders && !this.product.summedQuantity) {
                return {
                    className : 'is-static',
                    text : 'Sold Out',
                };
            }
            if(this.product.totalVariants >= 1) {
                return {
                    className : 'is-link',
                    text : 'View All Options',
                };
            }
            return null;
        },
        showSku () {
            return this.$store.state.dealer_portal.settings['show_sku'];
        },
        showQuantity () {
            return this.$store.state.dealer_portal.settings['show_quantity'];
        },
        allowBackorders () {
            return this.$getSessionContext().allowBackorders;
        },
    },
    methods : {
        buttonClick () {
            this.$router.push(this.linkTo);
        },
    },
}
</script>

<style lang="scss" scoped>
    @import '../../../assets/css/_theme';
    .product {
        min-height:80px;
        padding:20px 0;
        &:not(:last-child) {
            border-bottom: 1px solid $grey-lighter;
        }
        .images-col {
            flex:0 0 120px;
            text-align:center;
            a {
                color:$grey-lighter;
            }
            .primary-image {
                .fa {
                    font-size:50px;
                }
                img {
                    max-width:85px;
                    max-height:85px;
                }
            }
            .additional-images {
                & > div {
                    cursor:pointer;
                }
                .is-stretch {
                    height:100%;
                }
                img {
                    max-width:30px;
                    max-height:30px;
                }
            }
        }
        .end-col {
            flex:0 0 120px;
        }
        .meta {
            font-size:13px;
        }
        .heading {
            margin-bottom:8px;
            line-height:20px;
            font-size:17px;
        }
        .description {
            margin-top:8px;
            color:$grey;
            font-size:13px;
        }
        .price {
            color:$black;
            font-weight:bold;
            font-size:22px;
            margin-bottom:10px;
            text-align:center;
            &.none {
                font-size:14px;
            }
        }
        .button {
            height:26px;
            width:220px;
            text-transform:uppercase;
            font-size:13px;
            font-weight:bold;
        }
    }
</style>
